define('views/parts/feedback/feedback-button',[
    // Libs
    'backbone', 'mustache',
    // views
    'views/parts/feedback/send-feedback-modal',

], function(
    // Libs
    Backbone, Mustache,
    // views
    VSendFeedbackModal
) {

    var VFeedbackButton = Backbone.Epoxy.View.extend({
        template: '<a>{{ label }}</a>',

        events: {
            'click': 'onLabelClick'
        },

        initialize: function(opt) {
            this.options = opt;
            this.model = new Backbone.Model({ message: '' });
        },

        render: function() {
            this.$el.empty().append(
                Mustache.render(this.template, Mustache.getContext(this.options))
            );

            return this;
        },

        onLabelClick: function() {
            (new VSendFeedbackModal(this.options)).render();
        }
    });

    return VFeedbackButton;
});

